const STORAGE_KEY = 'pageContext';

type StoredState = {
  currentContext: unknown;
  pathname: string | null;
  previousContext: unknown;
};

function load(): StoredState {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw) return JSON.parse(raw);
  } catch {
    // sessionStorage may be unavailable
  }

  return { currentContext: null, pathname: null, previousContext: null };
}

function save(state: StoredState) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    // sessionStorage may be unavailable
  }
}

export function setPageContext<T = unknown>(context: T) {
  const state = load();

  state.currentContext = context;
  save(state);
}

export function getCurrentContext<T = unknown>(): T | null {
  return (load().currentContext as T) ?? null;
}

export function getPreviousContext<P = unknown>(): P | null {
  return (load().previousContext as P) ?? null;
}

export function rotatePageContext(pathname: string) {
  const state = load();

  if (pathname === state.pathname) return;

  state.previousContext = state.currentContext;
  state.currentContext = null;
  state.pathname = pathname;
  save(state);
}
